import { useEffect, useRef, useState } from 'react';

/**
 * Hook for ensuring accessibility on a non-modal popover.
 * 1) Focus should land on first interactive element when popover is triggered open.
 * 2) Focus should return to trigger button when the popover is closed/escaped from.
 */
export const usePopoverFocus = () => {
  const openBtnRef = useRef<HTMLElement | null>(null);
  const firstInteractiveEleRef = useRef<HTMLElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [touched, setTouched] = useState(false);

  const toggleOn = () => {
    setTouched(true);
    setIsOpen(true);
  };

  const toggleOff = () => {
    setTouched(true);
    setIsOpen(false);
  };

  useEffect(() => {
    if (touched && !isOpen) {
      openBtnRef.current?.focus();
    } else {
      firstInteractiveEleRef.current?.focus();
    }
  }, [isOpen, touched]);

  return { isOpen, toggleOn, toggleOff, openBtnRef, firstInteractiveEleRef };
};
